import ModalDialog from '@ui/modal/ModalDialog';
import Button from '@ui/button/Button';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
const SuggestedCountryModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [modalData, setModalData] = useState();
    useEffect(() => {
        if (sessionStorage.getItem('suggested-country') != 'closed') {
            api.checkGeolocationCountryMatch(window.country.toLowerCase()).then((data) => {
                if (data.error) {
                    return;
                }
                if (!data.countryMatch) {
                    setOpen(true);
                    setModalData(data);
                }
                else {
                    customEventBus.emit('suggestedCountry:close', {});
                }
            });
        }
        else {
            customEventBus.emit('suggestedCountry:close', {});
        }
    }, []);
    const onCloseModal = () => {
        sessionStorage.setItem('suggested-country', 'closed');
        // Manage newsletter popup Show
        customEventBus.emit('suggestedCountry:close', {});
    };
    if (!modalData) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalDialog, { isOpen: open, onRequestClose: () => {
                setOpen(false);
                onCloseModal();
            }, overlayClassName: "mobile-visible", contentLabel: t('modal.suggestedcountry.title'), className: "suggested-country-modal" },
            React.createElement(React.Fragment, null,
                React.createElement("p", null, t('modal.suggestedcountry.description1', { 0: modalData.IPCountryName })),
                React.createElement("p", { className: "mb-28" }, t('modal.suggestedcountry.description2')),
                React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: () => {
                        onCloseModal();
                        window.location.href = `${window.location.origin}/${modalData.defaultLanguage}-${modalData.IPCountryCode.toLowerCase()}`;
                    } }, t('modal.suggestedcountry.changelocation')),
                React.createElement("div", { className: "text-center" },
                    React.createElement(Button, { type: "button", cls: ['button--secondary'], onClick: () => {
                            onCloseModal();
                            setOpen(false);
                        } }, t('modal.suggestedcountry.remaininthe', { 0: window.countryname })),
                    React.createElement(Button, { type: "button", cls: ['button--tertiary', 'button--arrow-right'], onClick: () => {
                            setOpen(false);
                            onCloseModal();
                            props.setCountrySelectorOpen(true);
                        } }, t('modal.suggestedcountry.chose')))))));
};
export default SuggestedCountryModal;
